// import { createPopper } from '@popperjs/core';
import { ref, onBeforeUnmount, watchEffect } from 'vue';

export const usePopper = (triggerRef, dropdownRef, options) => {
    const popperInstance = ref(null);

    const initializePopper = async () => {
        if (popperInstance.value) return;

        const triggerEl = triggerRef.value?.$el || triggerRef.value;
        const dropdownEl = dropdownRef.value?.$el || dropdownRef.value;

        if (!triggerEl || !dropdownEl || !triggerEl.getBoundingClientRect) {
            return;
        }

        const { createPopper } = await import('@popperjs/core');

        popperInstance.value = createPopper(triggerEl, dropdownEl, {
            ...options,
        });
    };

    const updatePopper = () => {
        popperInstance.value?.update();
    };

    const destroyPopper = () => {
        if (popperInstance.value) {
            popperInstance.value.destroy();
            popperInstance.value = null;
        }
    };

    watchEffect(() => {
        if (popperInstance.value && options.value) {
            updatePopper();
        }
    });

    onBeforeUnmount(() => {
        destroyPopper();
    });

    return {
        initializePopper,
        updatePopper,
        destroyPopper,
    };
};
